import { render, staticRenderFns } from "./CompareKA.vue?vue&type=template&id=0b55b488"
import script from "./CompareKA.vue?vue&type=script&lang=js"
export * from "./CompareKA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports